import { useEffect, useRef, useState } from 'react';

// eslint-disable-next-line import/prefer-default-export
export const usePrevious = function (value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useLoaded = () => {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => setLoaded(true), []);
  return loaded;
};

export function getColorFromScheme(type) {
  switch (type) {
    case 'success': return 'emerald';
    case 'warning': return 'orange';
    case 'error': return 'red';
    case 'neutral': return 'gray';
    default: return type || 'gray';
  }
}
